module.exports = __webpack_public_path__ + "public/Icons/MapMarker/availableDrivers.png?994377cf";